import React, { useState, useRef, useEffect } from 'react';
import PreLoaderWidget from '../../../components/Loader';
import { Link } from "react-router-dom";

import { getLoggedInUser } from "../../../helpers/authUtils";
import moment from "moment";
//import RowCard from "../../../components/RowCard";
import NewComentarioContent from "../../../components/Comentario/newComent";
import ModalComponent from "../../../components/Modal";
import Historico from "../../../components/Historico";
import IconEvolucao from '../../../assets/svg/dadospaciente/ic-medicine-heart-beat.svg';

import CardAnamnese from './components/CardAnamnese';

const ContAnamnese = ({
    interacao,
    historico,
    usuario,
    idPaciente,
    aba,
    paciente,
    loadingHist,
    carregando,
    block,
    txtComent,
    idComent,
    _setResponder,
    _setComentario,
    _clearIdComent
}) => {

    const [openModalHistorico, setOpenModalHistorico] = useState(false);
    const [itemHistorico, setItemHistorico] = useState(null);
    const [more, setMore] = useState(false);
    const nameInput = useRef();
    const anchorTarget = useRef();

    const openModal = (item) => {
        setOpenModalHistorico(true);
        setItemHistorico(item);
    }

    const setResp = (id, type, desc, prof) => {
        _setResponder(id, type, desc, prof);
        anchorTarget.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    const buildHistorico = (item, index) => {
        if (item.type === "historico") {
            return (
                <div className="row" key={index}>
                    <div className="col-sm-11">

                        <CardAnamnese
                            interacao={interacao}
                            item={itemHistorico}
                            usuario={usuario}
                            idPaciente={idPaciente}
                            aba={aba}
                            pacienteId={paciente.id}
                            card={"historico"}
                            idHistorico={item.id}
                            profissional={item.profissional != null ? item.profissional.nome : ''}
                            exames={item.historico.exames}
                            observacao={item.historico.Observacao}
                            queixa={item.historico.queixa}
                            Hora={item.historico.Hora ? item.historico.Hora : null}
                            midias={
                                item.listMidia
                                    ? item.listMidia.map(
                                        item => {
                                            let src = item.midia.linkStorage ? 'https://us-central1-globalbrain-ba498.cloudfunctions.net/pdf/getCardiofit?link=' + item.midia.linkStorage : item.midia.url;
                                            return { src, alt: '', data: item.midia.data }
                                        }
                                    )
                                    : null
                            }
                            especialidade={item.historico.especialidade}
                            historico={item.historico.historico}
                            refProfissional={item.historico.refProfissional}
                            DataCriacao={item.historico.DataCriacao}
                            OpenModal={() => openModal(item)}
                            _setResponder={() => setResp(item.id, 'historico', 'Histórico: ' + item.profissional.nome + " - " + item.historico.DataCriacao.replace("-", "/").replace(
                                "-",
                                "/"
                            ) + " " + item.historico.Hora, item.historico.refProfissional)}
                        />
                    </div>
                    <div
                        id={item.id}
                        className="col-sm-1"
                        style={{ textAlign: "center", display: item.profissional && getLoggedInUser().username === item.profissional.nome ? null : 'none' }}
                    >
                        {/* <ScrollableAnchor id={item.id}><div>{' '}</div></ScrollableAnchor> */}


                        <img src={IconEvolucao} width="39" style={{ marginTop: 10 }} />
                        <small><br />Evolução </small>
                    </div>
                </div>
            );

        } else {
            return (
                <div className="row" key={index}>
                    <div className="col-sm-10">
                        <CardAnamnese
                            item={itemHistorico}
                            usuario={usuario}
                            idPaciente={idPaciente}
                            aba={aba}
                            pacienteId={paciente.id}
                            card={"comentario"}
                            idHistorico={item.id}
                            profissional={item.nomeProfissional}
                            interacao={interacao}
                            especialidade={
                                ''
                            }
                            comentario={item.comentario.comentario}
                            refDesc={item.comentario.refDesc}
                            refComent={item.comentario.refComent}
                            refType={item.comentario.refType}
                            refId={item.comentario.refComent ? item.comentario.refComent.id : null}
                            refProfissional={
                                item.comentario.refProfissional
                            }
                            DataCriacao={
                                moment(item.dt).format('DD/MM/YYYY HH:mm:ss')
                            }
                            OpenModal={() => openModal(item)}
                            _setResponder={() => setResp(item.id, 'coment', 'Comantário: || - ' + moment(item.dt).format('DD/MM/YYYY HH:mm:ss'), item.comentario.refProfissional)}

                        />
                    </div>
                    <div id={item.id}
                        className="col-sm-1"
                        style={{ textAlign: "center", display: getLoggedInUser().username === item.nomeProfissional ? null : 'none' }}>
                        {/* <ScrollableAnchor id={item.id}><div>{' '}</div></ScrollableAnchor> */}

                        <i className="fas fa-comment" style={{ fontSize: 20, marginTop: 10 }} />
                        <small>Comentário</small>
                    </div>
                </div>
            );
        }
    }

    return (
        <>
            <div className="container p-2">

                {historico && historico.length > 0
                    ? more
                        ?
                        <React.Fragment>
                            {historico.map((item, index) => {
                                return buildHistorico(item, index)
                            })}
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <Link
                                        to="#"
                                        className="btn gb-button"
                                        onClick={() => { setMore(false) }}>
                                        <i className="fa fa-minus-circle mr-2" /> Mostrar menos
                                    </Link>
                                </div>
                            </div>
                        </React.Fragment>
                        :
                        <React.Fragment>
                            {buildHistorico(historico[0], 0)}
                            <div className='row'>
                                <div className='col-sm-12'>
                                    <Link
                                        to="#"
                                        className="btn gb-button"
                                        onClick={() => { setMore(true) }}>
                                        <i className="fa fa-plus mr-2" /> Carregar mais
                                    </Link>
                                </div>
                            </div>
                        </React.Fragment>
                    : null
                }
                {/*  {loadingHist ? (<PreLoaderWidget />) : null}
                {carregando ? (<div className="text-center" style={{ textAlign: 'center' }}><center>
                    <PreLoaderWidget ></PreLoaderWidget>
                    carregando...
                </center></div>)
                    : null
                } */}
                <div className='row'>
                    <div className='col-sm-12'>
                        <div ref={anchorTarget} id='scrResposta'>
                            {!block && interacao ? (
                                <NewComentarioContent
                                    ref={nameInput}
                                    //card={card}
                                    card={'historico'}
                                    _setComentario={(coment) => _setComentario(coment)}
                                    txt={txtComent}
                                    idComent={idComent}
                                    _clearIdComent={() => _clearIdComent()}
                                    user={getLoggedInUser()}
                                ></NewComentarioContent>
                            ) : (<div ref={nameInput}></div>)}
                        </div>
                    </div>
                </div>
            </div>


            <ModalComponent
                style={{ zIndex: 99999 }}
                openModal={openModalHistorico}
                closeModal={() => setOpenModalHistorico(false)}
            >
                <Historico
                    item={itemHistorico}
                    usuario={usuario}
                    idPaciente={idPaciente}
                    aba={""}
                />
            </ModalComponent>
        </>
    )
}

export default ContAnamnese;